const dateFormat = new Intl.DateTimeFormat(undefined, { dateStyle: "medium" });
const dateTimeFormat = new Intl.DateTimeFormat(undefined, {
  dateStyle: "medium",
  timeStyle: "medium",
});

/** A server timestamp to the second, such as "14 Oct 2026, 09:00:01". */
export function formatDateTime(iso: string): string {
  return dateTimeFormat.format(new Date(iso));
}

/** A server timestamp as a date in the reader's locale, such as "14 Oct 2026". */
export function formatDate(iso: string): string {
  return dateFormat.format(new Date(iso));
}

/** A server timestamp as live's day, "16.10.2026" (day, month, year), whatever the locale: the
 *  detail headers and the actor info show it so. */
export function formatDay(iso: string): string {
  const day = new Date(iso);
  const two = (value: number) => String(value).padStart(2, "0");
  return `${two(day.getDate())}.${two(day.getMonth() + 1)}.${day.getFullYear()}`;
}

const countFormat = new Intl.NumberFormat();

/** A whole number with the reader's grouping, such as "1,000,000". */
export function formatCount(value: number): string {
  return countFormat.format(value);
}

// Live's GB of a team's storage, 1024³ bytes, and its pill's number: en-US, at most 2 decimals.
const STORAGE_GB = 1024 ** 3;
const storageFormat = new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 });

/** A team's stored bytes in live's GB, with no unit, as live's usage pill shows them
 * (`formatStorageAmount`; spec web/usage-pill-storage): "2.5", "0.01", "1,024". */
export function formatStorageGb(bytes: number): string {
  return storageFormat.format(bytes / STORAGE_GB);
}

/** A size in bytes as people read it: "512 B", "240 KB", "1.4 MB", "2.1 GB" (1,024 a step). */
export function formatBytes(bytes: number): string {
  const units = ["KB", "MB", "GB", "TB"];
  if (bytes < 1024) return `${bytes} B`;
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return unit === 0 ? `${Math.round(value)} KB` : `${value.toFixed(1)} ${units[unit]}`;
}

/** A count and its noun, singular for one: "1 file", "3 files" (a noun with a plain "s" plural). */
export function countOf(count: number, noun: string): string {
  return `${count} ${count === 1 ? noun : `${noun}s`}`;
}

/**
 * Live's picker line, "You can select up to N references" (products, images), in the singular
 * for one: live says "1 references" (issue 828, item 16; the lead's call, ours better than live).
 */
export function selectUpTo(count: number, noun: string): string {
  return `You can select up to ${countOf(count, noun)}`;
}

/** Live's refusal past an upload's room, "Maximum N files allowed", in the singular for one
 *  (live's "1 files"; issue 828, item 16). */
export function maximumFiles(room: number): string {
  return `Maximum ${countOf(room, "file")} allowed`;
}
